import {createSelector} from '@ngrx/store';

import {CANCELLATION_INVOICES_FEATURE_KEY, selectInvoicesModuleState} from '../reducers';

export const selectCancellationInvoicesState = createSelector(
  selectInvoicesModuleState,
  (state) => state[CANCELLATION_INVOICES_FEATURE_KEY]
);

export const selectCancellationInvoicesEntities = createSelector(
  selectCancellationInvoicesState,
  (state) => state.entities
);

export const selectCancellationInvoices = createSelector(
  selectCancellationInvoicesEntities,
  (customers) => Object.keys(customers).map(iri => customers[iri])
);

export const selectCancellationInvoiceByIndex = createSelector(
  selectCancellationInvoicesEntities,
  (customers, props) => customers[props.iri]
);

export const selectCurrentCancellationInvoice = createSelector(
  selectCancellationInvoicesState,
  (state) => state.current
);

/////////////////////////////////////////////////////////////////////////////////////////////////////////////// Search

export const selectSearchResultsIris = createSelector(
  selectCancellationInvoicesState,
  state => state.searchEntities
);

export const selectSearchResults = createSelector(
  selectCancellationInvoicesEntities,
  selectSearchResultsIris,
  (entities, selection) => selection.map(key => entities[key])
);

//////////////////////////////////////////////////////////////////////////////////////////////////////////// Pagination

export const selectTotalItems = createSelector(
  selectCancellationInvoicesState,
  state => state.totalItems
);
export const selectCancellationInvoicePagination = createSelector(
  selectCancellationInvoicesState,
  (state) => state.pagination
);
export const selectPaginationCurrentLink = createSelector(
  selectCancellationInvoicePagination,
  pagination => pagination.current
);
export const selectPaginationFirstLink = createSelector(
  selectCancellationInvoicePagination,
  pagination => pagination.first
);
export const selectPaginationPreviousLink = createSelector(
  selectCancellationInvoicePagination,
  pagination => pagination.previous
);
export const selectPaginationNextLink = createSelector(
  selectCancellationInvoicePagination,
  pagination => pagination?.next
);
export const selectPaginationLastLink = createSelector(
  selectCancellationInvoicePagination,
  pagination => pagination.last
);

//////////////////////////////////////////////////////////////////////////////////////////////////////// Loading States

export const isLoading = createSelector(
  selectCancellationInvoicesState,
  state => state.loading
);

export const isLoaded = createSelector(
  selectCancellationInvoicesState,
  state => state.loaded
);

//////////////////////////////////////////////////////////////////////////////////////////////////////////////// Errors

export const selectErrors = createSelector(
  selectCancellationInvoicesState,
  (state) => state.errors
);
